module.exports = __webpack_public_path__ + "img/default-avatar.a31c86f8.png";